import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderWidth,
        hfcHeaderInnerWidth,
        hfcTopHeaderBGcolor,
        hfcHeaderBGcolor,
        hfcHeaderIconsColor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderLinkCurrentColor,
        hfcHeaderBoxShadowColor,
        hfcHeaderSubmenuBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderSocialsColor,
        hfcHeaderSocialsBgColor,
        hfcHeaderIconSize,
        hfcHeaderIsTransparent,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHeaderDescBox

    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: ('hfc-header-' + clientIdSliced) });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();
    const ALLOWED_BLOCKS = [
        "core/group",
        "core/columns",
        "core/column",
        'hfc-blocks/icon-list',
        'hfc-blocks/list-item',
        "core/social-links",
        "core/social-link",
        "core/paragraph",
        "core/navigation",
        "core/navigation-link",
        "core/navigation-submenu",
    ];
    const TEMPLATE = [
        [
            "core/group",
            { tagName: "header" },
            [
                [
                    "core/group",
                    { className: "hfc-first-container" },
                    [
                        [
                            "core/columns",
                            { verticalAlignment: "center", className: "hfc-col-header-3" },
                            [
                                [
                                    "core/column",
                                    { width: "75%", className: "hfc-col-left" },
                                    [
                                        ["core/paragraph", { content: "Welcome to our DiviPot Website Services" }]
                                    ],
                                ],
                                [
                                    "core/column",
                                    { width: "25%", className: "hfc-col-right" },
                                    [
                                        [
                                            "core/social-links",
                                            { className: "social-link", align: "left" },
                                            [
                                                ["core/social-link", { service: "facebook", url: "#" }],
                                                ["core/social-link", { service: "x", url: "#" }],
                                                ["core/social-link", { service: "instagram", url: "#" }],
                                                ["core/social-link", { service: "youtube", url: "#" }],
                                            ],
                                        ],
                                    ],
                                ],
                            ],
                        ],
                    ],
                ],
                [
                    "core/group",
                    { className: "hfc-second-container" },
                    [
                        [
                            "core/columns",
                            { verticalAlignment: "center", className: "hfc-col-header-3" },
                            [
                                [
                                    "core/column",
                                    { width: "50%", className: "hfc-col-left" },
                                    [
                                        [
                                              "hfc-blocks/icon-list", {}, [
                                                ["hfc-blocks/list-item", {
                                                    spanText: "Requesting a Call<br><strong>(123) 456 789</strong>",
                                                    icon: "faPhone",
                                                    isLinkable: true,
                                                    url: 'tel:123456789'
                                                }]
                                              ]
                                        ],
                                        [
                                              "hfc-blocks/icon-list", {}, [
                                                ["hfc-blocks/list-item", {
                                                    spanText: "Monday - Friday<br><strong>9am - 4pm</strong>",
                                                    icon: "faClock"
                                                }]
                                              ]
                                        ],
                                    ],
                                ],
                                [
                                    "core/column",
                                    { width: "50%", className: "hfc-col-right" },
                                    [
                                        [
                                              "hfc-blocks/icon-list", {}, [
                                                ["hfc-blocks/list-item", {
                                                    spanText: "info@example.com<br><strong>mail to us</strong>",
                                                    icon: "faEnvelope",
                                                    isLinkable: true,
                                                    url:'mailto:info@example.com'
                                                }]
                                              ]
                                        ],
                                        [
                                              "hfc-blocks/icon-list", {}, [
                                                ["hfc-blocks/list-item", {
                                                    spanText: "122, Race Course<br><strong>Comilla</strong>",
                                                    icon: "faClock"
                                                }]
                                              ]
                                        ],
                                    ],
                                ],
                            ],
                        ],
                    ],
                ],
                [
                    "core/group",
                    { className: "hfc-third-container" },
                    [
                        [
                            "core/columns",
                            { verticalAlignment: "center", className: "hfc-col-header-3" },
                            [
                                [
                                    "core/column",
                                    { width: "100%", className: "hfc-col-left" },
                                    [
                                        [
                                            "core/navigation",
                                            {   className: "hfc-nav-header-3",
                                                showSubmenuIcon: false,
                                                icon: "menu" 
                                            },
                                            [
                                                ["core/navigation-link", { label: "Home", url: "#" }],
                                                ["core/navigation-link", { label: "About", url: "#" }],
                                                [
                                                    "core/navigation-submenu",
                                                    { label: "Services", url: "#" , className: "hfc-submenu-wrapper" },
                                                    [
                                                        ["core/navigation-link", { label: "Demo-1", url: "#" }],
                                                        ["core/navigation-link", { label: "Demo-2", url: "#" }],
                                                        ["core/navigation-link", { label: "Demo-3", url: "#", title: "new",}],
                                                    ],
                                                ],
                                                ["core/navigation-link", { label: "Blog", url: "#",  description: '📢 Lorem ipsum dolor sit amet consectetur adipiscing elit, inceptos commodo hendrerit auctor convallis. <strong>Purus integer</strong> tristique tellus mauris a scelerisque arcu molestie lectus aenean.' }],
                                                ["core/navigation-link", { label: "Pricing", url: "#" }],
                                                ["core/navigation-link", { label: "Team", url: "#"}],
                                                ["core/navigation-link", { label: "Testimonial", url: "#" }],
                                                ["core/navigation-link", { label: "Contact", url: "#" }],
                                            ],
                                        ],
                                    ],
                                ],
                                [
                                    "core/column",
                                    { className: "hfc-col-center" },
                                    [
                                        ["core/site-logo", { className: "" }],
                                    ],
                                ],
                            ],
                        ],
                    ],
                ],
            ],
        ],
    ];
    
    const hfcDynamicStyles = `
    /* Theme Compatibility - GeneratePress */
    .editor-styles-wrapper .wp-block-hfc-blocks-header-3 .hfc-main-header-3 .block-editor-block-list__block{
        max-width: 100%!important;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-3 .wp-block-group__inner-container {
        padding: 0px!important;
        max-width: 100%;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-3 .hfc-first-container .hfc-col-right .wp-block {
        height: 100%;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-3 .wp-block {
        margin: 0px;
    }
    .editor-styles-wrapper .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__responsive-container-content .wp-block-navigation__container.block-editor-block-list__layout {
        gap: 28px;
    }
    .editor-styles-wrapper .hfc-col-header-3 .wp-block-social-link-anchor{
        background: transparent;
        padding: 4px;
    }
    .editor-styles-wrapper .hfc-third-container .wp-block-navigation__submenu-container .wp-block-navigation-item__content{
        padding: 8px 16px;
    }
    .editor-styles-wrapper .hfc-main-header-3 .wp-block-navigation__submenu-container .wp-block-navigation-item__label::after{
       display: none!important;
    }
    .block-editor-block-list__block.wp-block.wp-block-hfc-blocks-header-3{
        max-width: 100%;
    }
    #${id}.hfc-main-header-3 {
        width: 100% !important;
        max-width: 100% !important;
        padding-bottom: 10px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-right svg{
       fill: ${hfcHeaderSocialsColor};
       height: ${hfcHeaderIconSize}px;
       width: ${hfcHeaderIconSize}px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .wp-block-columns,
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-columns{
        max-width: ${hfcHeaderWidth};
        margin: auto;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-header-3,
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        display: flex;
        align-items: center!important;
        gap: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-columns{
        gap: 10px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container {
        background-color: ${hfcTopHeaderBGcolor};
        padding: 5px 20px;
        color: #fff;
    }
    #${id}.hfc-main-header-3 .hfc-first-container ul{
        margin: 0px;
        flex-wrap: nowrap;
        padding: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-left p{
        font-size: 14px;
        margin: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li{
        background-color: transparent;
        transition: 0.4s;
        list-style: none;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li:hover{
        background-color: ${hfcHeaderSocialsBgColor};
        border-radius: 100px;
        transform: scale(1)!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li a{
        display: flex;
        align-items: center;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .wp-block-columns .hfc-col-right{
        display: flex;
        justify-content: flex-end;
    } 
    #${id}.hfc-main-header-3 .hfc-second-container {
        padding: 20px;
        margin: 0;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 .wp-block-column{
       position: relative;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 .wp-block-column::before {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 0;
        border-left: 1px dashed #808080;
        left: 50%;
        transform: translateX(-50%);
   }
  #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main{
        margin-top: 0;
  }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner{
       align-items: flex-start;
    }
     #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon,
     #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover .fp-ip-icon{
        background-color: transparent;
     }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner svg{
        color: ${hfcHeaderIconsColor};
        height: ${hfcHeaderIconSize}px;
        width: ${hfcHeaderIconSize}px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover svg{
       color: ${hfcHeaderIconsColor}!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner span{
        line-height: 24px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover span,
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner a:hover{
       color: #000000!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p:first-child{
        font-size: 14px;
        font-weight: 500;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p:last-child{
        font-size: 18px;
        font-weight: 800;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 {
        display: flex;
        gap: 200px;
    }
     #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 .wp-block-column{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p{
        margin: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
        display: flex;
        gap: 40px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container{
        background-color: ${hfcHeaderBGcolor};
        color: #fff;
        padding: ${hfcHeaderPadding}px 20px;
        max-width: ${hfcHeaderWidth}
        margin: 0 auto;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        max-width: ${hfcHeaderInnerWidth}!important;
        margin: 0 auto;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .hfc-submenu-wrapper > .wp-block-navigation__submenu-container{
        margin-top: ${hfcHeaderPadding}px;
        align-items: normal;
        display: flex;
        flex-direction: column;
        height: 0;
        left: -1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        top: 100%;
        transition: opacity .1s linear;
        visibility: hidden;
        width: 0;
        z-index: 2;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .hfc-submenu-wrapper:hover > .wp-block-navigation__submenu-container{
        opacity: 1!important;
        overflow: visible!important;
        visibility: visible!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__submenu-container{
        border-top: 2px solid ${hfcHeaderSubmenuBorderColor};
        background-color: ${hfcHeaderBGcolor};
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3 ul.wp-block-navigation{
        display: flex;
        gap: 28px;
        position: relative;
        z-index: 999999;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content {
        color: ${hfcHeaderLinksColor};
        transition: 0.4s;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
        line-height: 27px;
        text-decoration: none;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover{
        text-decoration: none!important;
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"] {
      color: ${hfcHeaderLinkCurrentColor} !important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__container > .wp-block-navigation-submenu > a{
        position: relative;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__container > .wp-block-navigation-submenu > a::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 4px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation-submenu > a:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    ${hfcHeaderTitleBadge ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]:after {
        content: attr(title);
        position: relative;
        top: -14px;
        font-size: 10px;
        font-weight: bold;
        line-height: 10px;
        text-transform: uppercase;
        display: inline;
        padding: 3px 4px;
        background: #F44336;
        color: #fff;
    }
    #${id} ul.hfc-nav-header-3 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after {
      top: 0;
      left: 10px;
      height: 100%;
    }` : ``}
    ${hfcHeaderDescBox ? `#${id}.hfc-main-header-3 .wp-block-navigation-item__content:hover .wp-block-navigation-item__description {
        display: block;
        position: absolute;
        top: 100%;
        background: #fff;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
        min-width: 250px !important;
        text-align: center;
        padding: 10px;
        border-radius: 5px;
        font-size: 14px;
        font-weight: normal;
        line-height: 21px;
        color: #000;
        z-index: 1;
    }`  : `#${id} .wp-block-navigation .wp-block-navigation-item__content:hover .wp-block-navigation-item__description{
        display: none;}`}

    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-left .wp-block-navigation-submenu:hover > a{
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center{
       display: flex;
       justify-content: center;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center img{
       height: auto;
       width: 120px;
    }
    ${hfcHeaderIsSticky ? `
    @media (min-width: 1024px) {
        #${id}.hfc-main-header-3 {
            position: sticky;
            top: -100px;
            z-index: 999;
        }
    }
` : ``}
    ${hfcHeaderIsTransparent ? `.hfc-main-header-3 {
        position: absolute;
        top: 0;
    }` : ``}
    ${hfcHeaderBoxShadow ? `#${id}.hfc-main-header-3 .hfc-third-container{
        box-shadow: ${hfcHeaderBoxShadowColor} 4px 4px 0px;
    }` : ``}
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close svg,
     #${id} .hfc-nav-header-3 .wp-block-navigation__responsive-container-open svg {
        fill: ${hfcHeaderLinksColor};
        width: 24px;
        height: 24px;
        transition: .3s;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }
    #${id} .hfc-icon-list-main .fp-ip-inner a{
        color: #000000;
    }

    /* Responsive */
    @media (min-width: 599px) {
         #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content .wp-block-navigation-item__description{
            position: absolute;
            top: 100%;
            background: #fff;   
            min-width: 250px;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
            text-align: center;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.5;
            color: #000;
            z-index: 1;
            display: none;
            white-space:normal;
        }
         ${hfcHeaderDescBox ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:hover .wp-block-navigation-item__description {
            display: block;
    }`  : ``}
        #${id} .wp-block-navigation .hfc-nav-header-3 > .wp-block-navigation-item.has-mega-menu,
        #${id} .wp-block-navigation .hfc-nav-header-3 >.wp-block-navigation-item.has-child{
            padding-right: 15px;
    }
    }
    @media(max-width: 1240px){
        #${id}.hfc-main-header-3 .hfc-third-container{
            margin: 0 20px!important;
        }
    }
    @media (max-width: 1120px){
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
            display: flex;
            gap: 20px!important;
        }
    }
    @media (max-width: 1080px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3{
            gap: 0px!important;
        }
    }
    @media (max-width: 920px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3{
            display: flex;
            flex-direction: column!important;
            gap: 20px!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3 .wp-block-columns{
            max-width: 600px!important;
            gap: 70px!important;
        }
    }
    @media (max-width: 866px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .wp-block-column{
            flex-basis: 50%!important;
            margin-bottom: 0px;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-right{
            justify-content: flex-end!important;
        }
    }
    @media (max-width: 840px){
        #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3 ul.wp-block-navigation{
            display: flex;
            gap: 15px;
            font-size: 15px;
        }
    }
    @media (max-width: 782px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-left p{
            text-align: left;
            font-size: 14px!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-right{
            justify-content: flex-end!important;
        }
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
           gap: 20px!important;
        }
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns .wp-block-column:first-child,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns .wp-block-column:first-child{
            border: none!important;
        }
        #${id}.hfc-main-header-3 .hfc-third-container .wp-block-columns{
            display: flex;
            align-content: center!important;
            flex-direction: column!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3 .wp-block-columns{
            gap: 20px!important;
        }
    }
    @media (max-width: 599px){
           /* Reset */
    p,li{
        font-size: 16px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container,
    #${id}.hfc-main-header-3 .hfc-second-container{
        padding: 10px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container ul{
       gap: 5px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container{
        position: relative;
        margin: 0!important;
        box-shadow: none;
        padding: 20px 10px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-flow: dense;
        direction:rtl;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center{
        justify-content: flex-end;
    }
    #${id}.hfc-main-header-3 .hfc-col-header-3 .hfc-col-center img{
        width: 120px;
    }
    #${id} .hfc-nav-header-3:has(.has-modal-open) .wp-block-navigation__responsive-container-open{
      display: none !important;
   }
    #${id} .hfc-cols-header-3 .wp-block-navigation__responsive-container.is-menu-open {
      animation: none;
   }
   #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open{
      position: absolute !important;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      transition: 0.4s;
    }
    #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close{
      position: absolute;
      top: -40px;
      right: 15px;
      z-index: 9999;
      background-color: transparent!important;
      transition: 0.4s;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open::before, 
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close::before{
        content: "Menu";
        font-size: 14px;
        position: absolute;
        font-weight: bold;
        color:${hfcHeaderLinksColor};
        right: 20px;
        top: 5px;
        white-space: nowrap;
        line-height: 1;
        text-transform: uppercase;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover::before, 
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close:hover::before{
        color: ${hfcHeaderLinksHoverColor};
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close svg,
     #${id} .hfc-nav-header-3 .wp-block-navigation__responsive-container-open svg,
     #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner svg{
        width: 20px;
    }
    #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover{
       background-color: transparent!important;
    }
    #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover svg{
       fill: ${hfcHeaderLinksHoverColor}!important;
    }
     #${id}.hfc-main-header-3 .hfc-nav-header-3 .wp-block-navigation__responsive-dialog{
      margin-top: 0!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-content{
      padding-top: 0!important;
    }
     #${id}.hfc-main-header-3 header.wp-block-group .wp-block-columns {
        flex-direction: row;
        flex-wrap: nowrap !important;
        gap: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-nav-header-3 .wp-block-navigation-item .wp-block-navigation-item__content:hover{
       background-color: ${hfcSubmenusBgHoverColor}!important;
    }
    /* Mobile Menu Inner */
     #${id}.hfc-main-header-3 .wp-block-navigation:not(.has-background) .wp-block-navigation__responsive-container.is-menu-open{
        background-color: transparent!important
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open{
        padding: 0px;
        height: 100vh;
        position: absolute;
        top: 100%;
        width: 100%;
        margin-top: 1px;
        overflow: visible;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation {
        display: block !important;
        width: 100%;
        background-color: #18202B!important;
        text-align: left;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container.is-menu-open a.wp-block-navigation-item__content {
        display: inline-block;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        font-size: 14px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover .wp-block-navigation-item__label:before{
       border-color: ${hfcHeaderLinksHoverColor};
    }
     #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
     #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
        border-bottom: none!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-item:not(:last-child) {
        border-bottom: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation-item.has-child .wp-block-navigation-submenu li:first-child {
        border-top: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open ul.wp-block-navigation-submenu {
        padding: 0;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container .wp-block-navigation__submenu-container {
        width: 100% !important;
        border-top: none!important;
    }
     #${id} .hfc-nav-header-3 ul.wp-block-navigation__submenu-container {
        display: none !important;
    }
     #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:before {
        background: none !important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation-item.has-child li a {
        padding: 10px 0 !important;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child {
        border-bottom: none;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child > a {
        position: relative;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        right: 18px;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 > li.wp-block-navigation-item.has-child > a::before,
     #${id} .hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 100%;
        width: 50px;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child > a::after {
        top: 20px;
        right: 20px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child {
        position: relative!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label{
        position: relative!important;
        padding-left: 30px!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        content: '';
        position: absolute;
        left: 10px;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(-45deg);
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content::after{
        content: '';
        position: absolute;
        right: 20px;
        height: 8px;
        width: 8px;
        top: 20px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before{
        top: 20px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        top: 5px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:hover:before,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
    }
    #${id} .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::after{
        top: 20px!important;
        right: 20px;
    }
    #${id} .hfc-second-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
       padding: 0px!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner span{
       font-size: 14px;
    }
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        right: 10px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first,
    #${id} .hfc-mm-4 .hfc-mm-cols-second {
        direction: ltr;
    }
    }
    /* Edit Page Compatibility */
    .editor-styles-wrapper{
        margin: 0px;
    }
    .editor-styles-wrapper .wp-block-navigation__container{
       justify-content: flex-start;
    }
    .editor-styles-wrapper .block-list-appender{
       display: none!important;
    }
    .editor-styles-wrapper .hfc-first-container .block-editor-block-list__block  p{
        margin: 0px!important;
        color: #fff;
    }
    .editor-styles-wrapper .wp-block-post-content {
        padding: 0px;
    }
    .editor-styles-wrapper .hfc-first-container ul{
        display: flex;
    }
    .editor-styles-wrapper .hfc-first-container .block-editor-block-list__block.wp-social-link .components-button {
        background-color: transparent!important;
        border: none!important;
    }
    .editor-styles-wrapper .hfc-first-container .block-editor-block-list__block.wp-social-link .components-button svg{
        height: 24px;
        width: 24px;
    }
    .editor-styles-wrapper .hfc-third-container a{
        text-decoration: none;
        font-size: 16px;
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Header Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <Heading className={'frhd__pb-heading'}>Header Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcHeaderPadding: newValue })}
                    isDragEnabled
                    value={hfcHeaderPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Header Width :')}
                    onChange={newValue => setAttributes({ hfcHeaderWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcHeaderWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Header Inner Width :')}
                    onChange={newValue => setAttributes({ hfcHeaderInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcHeaderInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Header Icon Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcHeaderIconSize: newValue })}
                    isDragEnabled
                    value={hfcHeaderIconSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Top Header Background Color :</Heading>
                <ColorPalette
                    value={hfcTopHeaderBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcTopHeaderBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Main Header Background Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Icons Color :</Heading>
                <ColorPalette
                    value={hfcHeaderIconsColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderIconsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Hover Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Link Current Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinkCurrentColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinkCurrentColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Box Shadow Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBoxShadowColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBoxShadowColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Submenu Border Color :</Heading>
                <ColorPalette
                    value={hfcHeaderSubmenuBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderSubmenuBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Submenu BG Hover Color :</Heading>
                <ColorPalette
                    value={hfcSubmenusBgHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcSubmenusBgHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Socials Icon Color :</Heading>
                <ColorPalette
                    value={hfcHeaderSocialsColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderSocialsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Socials Background Color :</Heading>
                <ColorPalette
                    value={hfcHeaderSocialsBgColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderSocialsBgColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHeaderIsSticky
                            ? 'Header Sticky :'
                            : 'Header Sticky :'
                    }
                    checked={hfcHeaderIsSticky}
                    onChange={newValue => setAttributes({ hfcHeaderIsSticky: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderBoxShadow
                            ? 'Header Box Shadow :'
                            : 'Header Box Shadow :'
                    }
                    checked={hfcHeaderBoxShadow}
                    onChange={newValue => setAttributes({ hfcHeaderBoxShadow: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderTitleBadge
                            ? 'Show Title as Badge :'
                            : 'Show Title as Badge :'
                    }
                    checked={hfcHeaderTitleBadge}
                    onChange={newValue => setAttributes({ hfcHeaderTitleBadge: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                    <ToggleControl
                    label={
                        hfcHeaderDescBox
                            ? 'Description on Hover :'
                            : 'Description on Hover :'
                    }
                    checked={hfcHeaderDescBox}
                    onChange={newValue => {
                        console.log('Toggle Value:', newValue);
                        setAttributes({ hfcHeaderDescBox: newValue });
                    }}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-3'}>
               <InnerBlocks
               allowedBlocks={ALLOWED_BLOCKS}
               template={TEMPLATE}
               />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderWidth,
        hfcHeaderInnerWidth,
        hfcTopHeaderBGcolor,
        hfcHeaderBGcolor,
        hfcHeaderIconsColor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderLinkCurrentColor,
        hfcHeaderBoxShadowColor,
        hfcHeaderSubmenuBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderSocialsColor,
        hfcHeaderSocialsBgColor,
        hfcHeaderIsTransparent,
        hfcHeaderIconSize,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHeaderDescBox
    } = attributes;

    const hfcDynamicStyles = `
    .block-editor-block-list__block.wp-block.wp-block-hfc-blocks-header-3{
        max-width: 100%;
    }
    #${id}.hfc-main-header-3 {
        width: 100% !important;
        max-width: 100% !important;
        padding-bottom: 10px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .wp-block-columns,
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-columns{
        max-width: ${hfcHeaderWidth};
        margin: auto;
    }
     #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-right svg{
       fill: ${hfcHeaderSocialsColor};
       height: ${hfcHeaderIconSize}px;
       width: ${hfcHeaderIconSize}px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-header-3,
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        display: flex;
        align-items: center!important;
        gap: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        gap: 10px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container {
        background-color: ${hfcTopHeaderBGcolor};
        padding: 5px 20px;
        color: #fff;
    }
    #${id}.hfc-main-header-3 .wp-block-group__inner-container {
        max-width: 100%!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container ul{
        margin: 0px;
        flex-wrap: nowrap;
        padding: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .hfc-col-left p{
        font-size: 14px;
        margin: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li{
        background-color: transparent;
        transition: 0.4s;
        list-style: none;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li:hover{
        background-color: ${hfcHeaderSocialsBgColor};
        border-radius: 100px;
        transform: scale(1)!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container li a{
        display: flex;
        align-items: center;
    }
    #${id}.hfc-main-header-3 .hfc-first-container .wp-block-columns .hfc-col-right{
        display: flex;
        justify-content: flex-end;
    } 
    #${id}.hfc-main-header-3 .hfc-second-container {
        padding: 20px;
        margin: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 .wp-block-column{
       position: relative;
       display: flex;
       align-items: center;
       justify-content: space-between;
       margin-bottom: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 .wp-block-column::before {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 0;
        border-left: 1px dashed #808080;
        left: 50%;
        transform: translateX(-50%);
   }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main{
        margin-top: 0;
   }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner{
       align-items: flex-start;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon,
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover .fp-ip-icon{
        background-color: transparent;
     }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner svg{
        color: ${hfcHeaderIconsColor};
        height: ${hfcHeaderIconSize}px;
        width: ${hfcHeaderIconSize}px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover svg{
       color: ${hfcHeaderIconsColor}!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner span{
        line-height: 24px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner:hover span,
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner a:hover{
       color: #000000!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p:first-child{
        font-size: 14px;
        font-weight: 500;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p:last-child{
        font-size: 18px;
        font-weight: 800;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-header-3 {
        display: flex;
        gap: 200px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3{
        display: flex;
        justify-content: center;
        position: unset;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .wp-block-column p{
        margin: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
        display: flex;
        gap: 40px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container{
        background-color: ${hfcHeaderBGcolor};
        color: #fff;
        padding: ${hfcHeaderPadding}px 20px;
        max-width: ${hfcHeaderWidth};
        margin: 0 auto;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        max-width: ${hfcHeaderInnerWidth};
        margin: 0 auto;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3 ul.wp-block-navigation{
        display: flex;
        gap: 28px;
        position: relative;
        z-index: 999999;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content {
        color: ${hfcHeaderLinksColor};
        transition: 0.4s;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
        line-height: 27px;
        text-decoration: none;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover{
        text-decoration: none!important;
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[aria-current="page"] {
        color: ${hfcHeaderLinkCurrentColor} !important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 > li.wp-block-navigation-item.has-child > a{
        position: relative;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 > li.wp-block-navigation-item.has-child > a::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 4px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 > li.wp-block-navigation-item.has-child > a:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    ${hfcHeaderTitleBadge ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]:after {
        content: attr(title);
        position: relative;
        top: -14px;
        font-size: 10px;
        font-weight: bold;
        line-height: 10px;
        text-transform: uppercase;
        display: inline;
        padding: 3px 4px;
        background: #F44336;
        color: #fff;
    }
    #${id} ul.hfc-nav-header-3 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after {
      top: 0;
      left: 10px;
      height: 100%;
    }` : ``}
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-left .wp-block-navigation-submenu:hover > a{
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center{
       display: flex;
       justify-content: center;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center img{
        height: auto;
        width: 120px;
    }
    ${hfcHeaderIsSticky ? `
    @media (min-width: 1024px) {
        #${id}.hfc-main-header-3 {
            position: sticky;
            top: -100px;
            z-index: 999;
        }
    }
` : ``}
    ${hfcHeaderIsTransparent ? `.hfc-main-header-3 {
        position: absolute;
        top: 0;
    }` : ``}
    ${hfcHeaderBoxShadow ? `#${id}.hfc-main-header-3 .hfc-third-container{
        box-shadow: ${hfcHeaderBoxShadowColor} 4px 4px 0px;
    }` : ``}
   
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close svg,
     #${id} .hfc-nav-header-3 .wp-block-navigation__responsive-container-open svg {
        fill: ${hfcHeaderLinksColor};
        width: 24px;
        height: 24px;
        transition: .3s;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }
    #${id} .hfc-icon-list-main .fp-ip-inner a{
        color: #000000;
    }
    @media (min-width: 599px) {
        ${hfcHeaderDescBox ? `#${id}.hfc-main-header-3 .wp-block-navigation-item__content:hover .wp-block-navigation-item__description {
            display: block;
            position: absolute;
            top: 100%;
            background: #fff;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
            min-width: 250px !important;
            text-align: center;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: normal;
            line-height: 21px;
            color: #000;
            z-index: 1;
        }`  : `#${id} .wp-block-navigation .wp-block-navigation-item__content:hover .wp-block-navigation-item__description{
            display: none;}`}
        #${id} .wp-block-navigation .hfc-nav-header-3 > .wp-block-navigation-item.has-mega-menu,
        #${id} .wp-block-navigation .hfc-nav-header-3 >.wp-block-navigation-item.has-child{
            padding-right: 15px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 ul.hfc-submenu-wrapper{
        background-color: transparent;
        border: 1px solid transparent;
        padding-top: ${hfcHeaderPadding}px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__submenu-container .hfc-submenu-wrapper-inner{
        background-color: ${hfcHeaderBGcolor};
        border: 1px solid #00000026;
        border-top: 2px solid ${hfcHeaderSubmenuBorderColor};
    }
    #${id} .wp-block-navigation.hfc-nav-header-3 .wp-block-navigation__submenu-container{
        background-color: ${hfcHeaderBGcolor};
        border-top: 2px solid ${hfcHeaderSubmenuBorderColor};
    }
    }

    @media(max-width: 1240px){
        #${id}.hfc-main-header-3 .hfc-third-container{
            margin: 0 20px!important;
        }
    }
    @media (max-width: 1120px){
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
            display: flex;
            gap: 20px!important;
        }
    }
    @media (max-width: 1080px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3{
            gap: 0px!important;
        }
    }
    @media (max-width: 920px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3{
            display: flex;
            flex-direction: column!important;
            gap: 20px!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3 .wp-block-columns{
            max-width: 600px!important;
            gap: 70px!important;
        }
    }
    @media (max-width: 866px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .wp-block-column{
            flex-basis: 50%!important;
            margin-bottom: 0px;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-right{
            justify-content: flex-end!important;
        }
    }
    @media (max-width: 840px){
        #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3 ul.wp-block-navigation{
            display: flex;
            gap: 15px;
            font-size: 15px;
        }
    }
    @media (max-width: 782px){
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-left p{
            text-align: left;
            font-size: 14px!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-first-container .wp-block-columns .hfc-col-right{
            justify-content: flex-end!important;
        }
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns{
           gap: 20px!important;
        }
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-left .wp-block-columns .wp-block-column:first-child,
        #${id}.hfc-main-header-3 .hfc-second-container .hfc-col-right .wp-block-columns .wp-block-column:first-child{
            border: none!important;
        }
        #${id}.hfc-main-header-3 .hfc-third-container .wp-block-columns{
            display: flex;
            align-content: center!important;
            flex-direction: column!important;
        }
        #${id}.hfc-main-header-3 header.wp-block-group .hfc-second-container .hfc-col-header-3 .wp-block-columns{
            gap: 20px!important;
        }
    }
    @media (max-width: 599px){
           /* Reset */
    p,li{
        font-size: 14px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container,
    #${id}.hfc-main-header-3 .hfc-second-container{
        padding: 10px!important;
    }
    #${id}.hfc-main-header-3 .hfc-first-container ul{
       gap: 5px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container{
        position: relative;
        margin: 0!important;
        box-shadow: none;
        padding: 20px 10px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-header-3{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-flow: dense;
        direction:rtl;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .hfc-col-center{
        justify-content: flex-end;
    }
    #${id}.hfc-main-header-3 .hfc-col-header-3 .hfc-col-center img{
        width: 120px;
    }
    #${id} .hfc-nav-header-3:has(.has-modal-open) .wp-block-navigation__responsive-container-open{
      display: none !important;
   }
    #${id} .hfc-cols-header-3 .wp-block-navigation__responsive-container.is-menu-open {
      animation: none;
   }
   #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open{
      position: absolute !important;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      transition: 0.4s;
    }
    #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close{
      position: absolute;
      top: -40px;
      right: 15px;
      z-index: 9999;
      background-color: transparent!important;
      transition: 0.4s;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open::before, 
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close::before{
        content: "Menu";
        font-size: 14px;
        position: absolute;
        font-weight: bold;
        color:${hfcHeaderLinksColor};
        right: 20px;
        top: 5px;
        white-space: nowrap;
        line-height: 1;
        text-transform: uppercase;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover::before, 
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close:hover::before{
        color: ${hfcHeaderLinksHoverColor};
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-close svg,
     #${id} .hfc-nav-header-3 .wp-block-navigation__responsive-container-open svg,
     #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner svg {
        width: 20px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover{
       background-color: transparent!important;
    }
    #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-open:hover svg{
       fill: ${hfcHeaderLinksHoverColor}!important;
    }
     #${id}.hfc-main-header-3 .hfc-nav-header-3 .wp-block-navigation__responsive-dialog{
      margin-top: 0!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container-content{
      padding-top: 0!important;
    }
     #${id}.hfc-main-header-3 header.wp-block-group .wp-block-columns {
        flex-direction: row;
        flex-wrap: nowrap !important;
        gap: 0px;
    }
    #${id}.hfc-main-header-3 .hfc-nav-header-3 .wp-block-navigation-item .wp-block-navigation-item__content:hover{
       background-color: ${hfcSubmenusBgHoverColor}!important;
    }
    /* Mobile Menu Inner */
     #${id}.hfc-main-header-3 .wp-block-navigation:not(.has-background) .wp-block-navigation__responsive-container.is-menu-open{
        background-color: transparent!important
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open{
        padding: 0px;
        height: 100vh;
        position: absolute;
        top: 100%;
        width: 100%;
        margin-top: 1px;
        overflow: visible;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation {
        display: block !important;
        width: 100%;
        background-color: #18202B!important;
        text-align: left;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container.is-menu-open a.wp-block-navigation-item__content {
        display: inline-block;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        font-size: 14px;
    }
    #${id}.hfc-main-header-3 .hfc-third-container .wp-block-navigation-item a.wp-block-navigation-item__content:hover .wp-block-navigation-item__label:before{
       border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
    #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
        border-bottom: none!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-item:not(:last-child) {
        border-bottom: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation-item.has-child .wp-block-navigation-submenu li:first-child {
        border-top: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open ul.wp-block-navigation-submenu {
        padding: 0;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation__responsive-container .wp-block-navigation__submenu-container {
        width: 100% !important;
        border-top: none!important;
    }
     #${id} .hfc-nav-header-3 ul.wp-block-navigation__submenu-container {
        display: none !important;
    }
     #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:before {
        background: none !important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation-item.has-child li a {
        padding: 10px 0 !important;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child {
        border-bottom: none;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child > a {
        position: relative;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        right: 18px;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 > li.wp-block-navigation-item.has-child > a::before,
     #${id} .hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 100%;
        width: 50px;
    }
     #${id} .wp-block-navigation.hfc-nav-header-3 li.wp-block-navigation-item.has-child > a::after {
        top: 20px;
        right: 20px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child {
        position: relative!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child a,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label{
        position: relative!important;
        padding-left: 30px!important;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        content: '';
        position: absolute;
        left: 10px;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(-45deg);
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content::after{
        content: '';
        position: absolute;
        right: 20px;
        height: 8px;
        width: 8px;
        top: 20px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before{
        top: 20px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        top: 5px;
    }
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:hover:before,
     #${id}.hfc-main-header-3 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
    }
    #${id} .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::after{
        top: 20px!important;
        right: 20px;
    }
    #${id} .hfc-second-container .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
       padding: 0px!important;
    }
    #${id}.hfc-main-header-3 .hfc-second-container .hfc-icon-list-main .fp-ip-inner span{
        font-size: 14px;    
    }
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        right: 10px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first,
    #${id} .hfc-mm-4 .hfc-mm-cols-second {
        direction: ltr;
    }
    }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-3'}>
                <InnerBlocks.Content/>
            </div>
        </>
    )
}